module.exports = __webpack_public_path__ + "static/media/double-sea-2-1.cc324e20.jpg";